import React from 'react'
import {  Grid, Typography, Button } from '@mui/material'
import { Card } from '@mui/material'
import colors from '../../colors'
import { useNavigate } from 'react-router';
import { ReactComponent as BankOptionLogo } from '../../../icons/BankOptionLogo.svg';
import { ReactComponent as CardOptionLogo } from '../../../icons/CardOptionLogo.svg';
import { ReactComponent as ShopOptionLogo } from '../../../icons/ShopOptionLogo.svg';
import { ReactComponent as BankTransferLogo } from '../../../icons/bankTransferLogo.svg';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts'

export const TopUpOptions = () => {

    const navigate = useNavigate()
    const userInfo = useSelector(selectUserInfo)
    const dispatch = useDispatch()

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }

    const onClickUrl = (url) => {
        return () => openInNewTab(url)
      }

    const useStyles = makeStyles({
        card:{
            width:'50%',
            borderRadius:'20px',
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'60%'},
            '@media (max-width: 1440px)' : {width:'70%'},
            '@media (max-width: 899px)' : {width:'60%'},
            '@media (max-width: 500px)' : {width:'90%'}
        },
        button:{
            width:'100%',
            height:"100%"
        },
        buttonTitle:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold', 
            textTransform:'none'
        },
        buttonText:{
            color:colors.darkBlue,
            fontSize:'0.8rem',
            fontFamily:'GerberaLight',
            textTransform:'none'
        }
    })

    const classes = useStyles()

  return (
    <Grid container pt={'2%'} rowSpacing={5} >
        <Grid container item md={12} spacing={5} >
            <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card  className={classes.card} >
                    <Button className={classes.button} disableRipple={true} onClick={()=>{navigate('topUpBankOptions')}}>
                        <Grid  container item md={12} xs={12} mt={3} mb={3} >
                            <Grid container item direction="column" justifyContent="center" alignItems="center" md={4} xs={4}  >
                                <Grid container item direction="column" justifyContent="center" alignItems="center" sx={{borderRadius:'20px', background:colors.veryLightGreen , width:'110px', height:'110px'}} ><BankOptionLogo /></Grid>
                            </Grid>
                            <Grid container item justifyContent="center" alignContent={'center'} md={7} xs={7} ml={2} rowSpacing={1} >
                                <Grid item md={10} xs={10} >
                                    <Typography className={classes.buttonTitle} textAlign='left'>{texts["title-topup-bank"]}</Typography>
                                </Grid>
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonText} textAlign='left'>{texts["message-topup-bank"]}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card className={classes.card} >
                    <Button className={classes.button} onClick={()=>{navigate('bankTransfer')}} >
                        <Grid  container item md={12} xs={12} mt={3} mb={3} >
                            <Grid container item direction="column" justifyContent="center" alignItems="center" md={4} xs={4}  >
                                <Grid container item direction="column" justifyContent="center" alignItems="center" sx={{borderRadius:'20px', background:colors.veryLightBlue , width:'110px', height:'110px'}} ><BankTransferLogo /></Grid>
                            </Grid>
                            <Grid container item md={7} xs={7} justifyContent="center" alignContent={'center'} ml={2} rowSpacing={1} >
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonTitle} textAlign='left'>{texts["title-bank-transfer"]}</Typography>
                                </Grid>
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonText}  textAlign='left'>{texts["message-subtitle-topup-bank-transfer"]}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
        </Grid>
        {userInfo.accountType !== 2 && 
        <Grid container item md={12} spacing={5} >
            <Grid container item md={6} xs={12} justifyContent={'right'}  sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card className={classes.card}>
                    <Button className={classes.button} onClick={()=>{navigate('topUpCard')}}>
                        <Grid  container item md={12} xs={12} mt={3} mb={3} >
                            <Grid container item direction="column" justifyContent="center" alignItems="center" md={4} xs={4}  >
                                <Grid container item direction="column" justifyContent="center" alignItems="center" sx={{borderRadius:'20px', background:colors.veryLightOrange , width:'110px', height:'110px'}} ><CardOptionLogo /></Grid>
                            </Grid>
                            <Grid container item md={7} xs={7} justifyContent="center" alignContent={'center'} ml={2} rowSpacing={1} >
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonTitle} textAlign='left'>{texts["button-topup-card"]}</Typography>
                                </Grid>
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonText} textAlign='left'>{texts["message-topup-card"]}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card  className={classes.card}>
                    <Button className={classes.button} onClick={()=>{navigate('topUpLocations')}}>
                        <Grid  container item md={12} xs={12} mt={3} mb={3} >
                            <Grid container item direction="column" justifyContent="center" alignItems="center" md={4} xs={4}  >
                                <Grid container item direction="column" justifyContent="center" alignItems="center" sx={{borderRadius:'20px', background:colors.lightOrange, width:'110px', height:'110px'}} ><ShopOptionLogo /></Grid>
                            </Grid>
                            <Grid container item md={7} xs={7} justifyContent="center" alignContent={'center'} ml={2} rowSpacing={1} >
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonTitle} textAlign='left' >{texts["title-toup-agent"]}</Typography>
                                </Grid>
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonText} textAlign='left' >{texts["message-topup-agent"]}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
        </Grid>
    }
    {/* <Grid container item md={12} spacing={5} >
            <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card  className={classes.card} >
                    <Button className={classes.button} disableRipple={true} onClick={()=>{navigate('cardOnFile')}}>
                        <Grid  container item md={12} xs={12} mt={3} mb={3} >
                            <Grid container item direction="column" justifyContent="center" alignItems="center" md={4} xs={4}  >
                                <Grid container item direction="column" justifyContent="center" alignItems="center" sx={{borderRadius:'20px', background:colors.veryLightGreen , width:'110px', height:'110px'}} ><CardOptionLogo /></Grid>
                            </Grid>
                            <Grid container item justifyContent="center" alignContent={'center'} md={7} xs={7} ml={2} rowSpacing={1} >
                                <Grid item md={10} xs={10} >
                                    <Typography className={classes.buttonTitle} textAlign='left'>Ruaj Karta</Typography>
                                </Grid>
                                <Grid item md={10} xs={10}  >
                                    <Typography className={classes.buttonText} textAlign='left'> Ruani kartat.</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}></Grid>
        </Grid> */}
    </Grid>
  )
}
export default TopUpOptions
